import { Component, Prop, h } from '@stencil/core';

import { HistoryIcon } from '../../../interfaces/interface.consumer-market-confidence';
import { trackAutoCheckSelection } from '../../../tracking/tracking.vehicleHistory';

@Component({
  tag: 'vehicle-history-report',
  styleUrl: 'vehicle-history-report.css',
})
export class VehicleHistoryReport {
  @Prop() autoCheckFullReportLink: string = '';
  @Prop() hasDealerEditedQuestion: boolean = false;
  @Prop() hasAccidents: boolean = false;
  @Prop() hasPriorRentals: boolean = false;
  @Prop() hasSingleOwner: boolean = true;
  @Prop() reportGeneratedOnDate: string = '';
  @Prop() vin: string = '';
  @Prop() historyIcons: HistoryIcon[] = [];

  onGetFullReportClick() {
    trackAutoCheckSelection();
  }

  render() {
    return (
      <div class="mb-14 flex flex-col justify-between items-center gap-4 mdLrg:flex-row">
        <div class="text-center mdLrg:text-left">
          <h3 class="text-lg">Vehicle History Report</h3>
          <div class="text-xs">VIN: {this.vin}</div>
          {this.reportGeneratedOnDate && <div class="text-xs">Report Generated On: {this.reportGeneratedOnDate}</div>}
          <div class="mt-2 text-xs">
            Information provided by AutoCheck<span>&#174;</span>{' '}
            <ico-hyperlink href={this.autoCheckFullReportLink} target="_blank" noUnderline class="xs:block mdLrg:inline" onClick={this.onGetFullReportClick}>
              Get full report
            </ico-hyperlink>
          </div>
        </div>
        <div class="text-center">
          <div class="flex flex-row xs:justify-center mdLrg:justify-start pb-1 flex-wrap">
            {this.historyIcons.map((iconInfo, index) => (
              <history-icon key={`${iconInfo.icon}-${index}`} icon={iconInfo.icon} label={iconInfo.label} container-class="w-36 h-16" label-class="text-sm" />
            ))}
          </div>
          <div class="text-xs">(This is not a full history report)</div>
        </div>
      </div>
    );
  }
}
